import { PapiGallection } from '@wix/da-papi-types';

export function isSpecialDefaultGallection(gallection?: PapiGallection) {
  if (gallection?.type === 'private_collection') {
    return gallection.name === 'Private';
  }
  return gallection?.name === 'Featured';
}
